import styled from 'styled-components';

export const IconWrapper = styled.div<{ size?: string }>`
  width: ${props => props.size || '24px'};
  height: ${props => props.size || '24px'};
  display: flex;
  align-items: center;
  justify-content: center;
`;